import { Link } from "react-router-dom"
import { toSalusionPrivate } from "../../util"

import logo from "../../assets/logo.svg"
import "./Footer.css"

export default function Footer() {
	return (
		<footer id="footer">
			<div className="footer-links-wrapper">
				<div className="container">
					<div className="row justify-content-center justify-content-md-end justify-content-lg-center">
						<div className="col-12 col-md-4 col-lg">
							<div className="footer-logo">
								<Link to="/">
									<img src={logo} alt="salusion logo" />
								</Link>
							</div>
						</div>

						<div className="col-6 col-md-4 col-lg">
							<div className="footer-links">
								<h5>Legal</h5>
								<Link to="privacy-policy">Privacy Policy</Link>
								<Link to="terms-of-service">Terms of Service</Link>
							</div>
						</div>

						<div className="col-6 col-md-4 col-lg">
							<div className="footer-links">
								<h5>Sitemap</h5>
								<Link to="/">Home</Link>
								<Link to="pricing">Pricing</Link>
								<Link to="partners">Partners</Link>
								<Link to="referral-program">Referrals</Link>

								<Link onClick={() => window.open("https://salusion.com/learning-center", "_blank")}>
									Learning Center
								</Link>
								<Link to="contact-us">Contact Us</Link>
							</div>
						</div>

						<div className="col-6 col-md-4 col-lg">
							<div className="footer-links">
								<h5>HRAs</h5>
								<a href="/learning-center/qsehra-administration">Qualified Small Employer</a>
								<a href="/learning-center/ichra-administration">Individual Coverage</a>
							</div>
						</div>

						<div className="col-6 col-md-4 col-lg">
							<div className="footer-links">
								<h5>Resources</h5>
								<Link onClick={(event) => toSalusionPrivate(event, "/calculator/metal-based-ichra-employer")}>
									Create a Metal-Based ICHRA
								</Link>
								<Link onClick={(event) => toSalusionPrivate(event, "/calculator/affordable-ichra-employer")}>
									Create an ACA-Compliant ICHRA
								</Link>

								<Link onClick={(event) => toSalusionPrivate(event, "/calculator/cost-of-insurance")}>
									Find the Cost of Insurance
								</Link>
								<Link onClick={(event) => toSalusionPrivate(event, "/calculator/plans")}>
									Plans Available on Exchange
								</Link>

								<Link onClick={(event) => toSalusionPrivate(event, "/calculator/affordable-ichra-employee")}>
									ICHRA Affordability Calculator
								</Link>
								<Link onClick={(event) => toSalusionPrivate(event, "/calculator/available-plans")}>
									Plans Available on Salusion
								</Link>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="footer-copyright">
				<p>2024 Salusion, Inc. All Rights Reserved</p>
			</div>
		</footer>
	)
}
